import {
  Component,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { debounce } from 'lodash';

@Component({
  selector: 'ops-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchBarComponent {
  @Output('searchedParamter') searchEmitter: EventEmitter<string> =
    new EventEmitter<string>();

  searchParameter: string;

  onSearchInput = debounce((searchParameter: string) => {
    this.searchEmitter.emit(this.searchParameter);
  }, 1000);
}
